export const TBPRO_WAIT_LIST = 'https://tb.pro/waitlist/';
